import { useTranslation } from '@kb/i18n';
import { useMutation } from '@ocp/graphql-client';
import { notifyDanger, notifySuccess } from '@ocp/notifications';
import i18nKeys from '../i18n/index';
export const UNSUBSCRIBE_CONTENT_MUTATION = `
  mutation deleteContentSubscription($classNameId: Long, $classPk: Long) {
    deleteContentSubscription(classNameId: $classNameId, classPk: $classPk)
  }
`;
const useUnsubscribeContentMutation = (classNameId, classPk, onMutate) => {
    const { t } = useTranslation();
    return useMutation(UNSUBSCRIBE_CONTENT_MUTATION, {
        variables: { classNameId, classPk },
        onCompleted: () => {
            notifySuccess(t(i18nKeys.YOUR_REQUEST_COMPLETED_SUCCESSFULLY));
            onMutate();
        },
        onError: (e) => {
            console.error(e);
            notifyDanger(t(i18nKeys.ERROR_IS_OCCURED));
        },
    });
};
export default useUnsubscribeContentMutation;
